import { Input, Select } from 'antd';
import { TagOutlined, UserOutlined, FlagOutlined } from '@ant-design/icons';
import MobileFilterPanel from '../../components/filters/MobileFilterPanel';
import DateRangePair from '../../components/filters/DateRangePair';
import { useActiveFilters } from '../../components/filters/useActiveFilters';
import { STATUS_OPTIONS } from './status';
import TagFilter from './TagFilter';
import type { FilterBarProps } from './filter.types';

/** 文章篩選（手機）：搜尋標題常駐，其餘條件收在「篩選」面板，兩欄排列。 */
export default function MobileFilterBar({
  categories,
  authors,
  onTitle,
  onCategory,
  onAuthor,
  onTag,
  onStatus,
  onDateRange,
}: FilterBarProps) {
  const { count, mark } = useActiveFilters();
  return (
    <MobileFilterPanel
      activeCount={count}
      search={<Input.Search placeholder="搜尋標題" allowClear onSearch={onTitle} />}
    >
      <Select
        placeholder="分類"
        allowClear
        suffixIcon={<TagOutlined />}
        className="w-full"
        onChange={(v?: string) => { mark('category', !!v); onCategory(v); }}
        options={categories}
      />
      <Select
        placeholder="作者"
        allowClear
        showSearch
        optionFilterProp="label"
        suffixIcon={<UserOutlined />}
        className="w-full"
        onChange={(v?: string) => { mark('author', !!v); onAuthor(v); }}
        options={authors}
      />
      <TagFilter full onChange={(v) => { mark('tag', !!v); onTag(v); }} />
      <Select
        placeholder="狀態"
        allowClear
        suffixIcon={<FlagOutlined />}
        className="w-full"
        onChange={(v?: string) => { mark('status', !!v); onStatus(v); }}
        options={STATUS_OPTIONS}
      />
      <DateRangePair
        placeholder={['發佈日（起）', '發佈日（迄）']}
        onChange={(f, t) => { mark('date', !!(f || t)); onDateRange(f, t); }}
      />
    </MobileFilterPanel>
  );
}
